import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';

interface DrawExplainerProps {
  cryptoComEnabled: boolean;
}

export const DrawExplainer = ({ cryptoComEnabled }: DrawExplainerProps) => {
  const { t } = useTranslation('product');

  return (
    <div className="mb-6">
      <div className="flex flex-col gap-y-3">
        <p className="whitespace-pre-line">
          {cryptoComEnabled ? (
            <Trans
              components={{
                0: (
                  <Link
                    className="hyperlink"
                    href="/support/allocation"
                    target="_blank"
                  />
                ),
              }}
              i18nKey="drawExplainer.crypto"
              t={t}
            />
          ) : (
            <Trans
              components={{
                0: (
                  <Link
                    className="hyperlink"
                    href="https://avantarte.com"
                    target="_blank"
                  />
                ),
                1: (
                  <Link
                    className="hyperlink"
                    href="mailto:collecting@avantarte.com"
                    target="_blank"
                  />
                ),
                2: (
                  <Link
                    className="hyperlink"
                    href="/support/releases#what-is-a-draw-release"
                    target="_blank"
                  />
                ),
                3: <strong />,
              }}
              i18nKey="drawExplainer.explainer"
              t={t}
            />
          )}
        </p>
      </div>
    </div>
  );
};
